export default __webpack_public_path__ + "static/media/SOAL NO 7. TUTORIAL GAMBAR.34f647f3.mp4";